import { RouteObject } from "react-router-dom";
import { WithAuth } from "../components/layout/with-auth/with-auth.component";
import { ViewAllTickets } from "../features/tickets/pages/view-all.page";
import { ViewTicket } from "../features/tickets/pages/view";

export const ticketsRoutes: RouteObject[] = [
  {
    path: "/t",
    element: (
      <WithAuth showHelp={false}>
        <ViewAllTickets />
      </WithAuth>
    ),
  },
  {
    path: "/t/:id",
    element: (
      <WithAuth showHelp={false}>
        <ViewTicket />
      </WithAuth>
    ),
  },
];
